import Joi from 'joi';
import { QuerySchema } from '../../common/joi-validation-schemas';
export const GetDataForQueryEventPayloadSchema = Joi.object({
    queries: Joi.array()
        .items(QuerySchema)
        .min(1)
        .required(),
}).unknown(false);
export const validateGetDataForQueryEventPayloadObject = (object) => {
    try {
        Joi.assert(object, GetDataForQueryEventPayloadSchema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
};
//# sourceMappingURL=util.js.map